import React, { FC } from "react";
import { UserProps } from "../User";
import { StyledDivider, StyledLink, StyledUserWrapper } from "./index.styled";

export const UserMobile: FC<{ user: UserProps }> = ({ user }) => {
  const {
    accountUrl,
    isLoggedIn,
    logInUrl,
    logOutUrl,
    onAccountClicked,
    onLogInClicked,
    onLogOutClicked,
    onSignUpClicked,
    signUpUrl,
  } = user;

  if (isLoggedIn)
    return (
      <StyledUserWrapper>
        <StyledLink href={accountUrl} onClick={onAccountClicked}>
          Account
        </StyledLink>
        <StyledDivider />
        <StyledLink href={logOutUrl} onClick={onLogOutClicked}>
          Log Out
        </StyledLink>
      </StyledUserWrapper>
    );
  else if (!!signUpUrl || !!onSignUpClicked)
    return (
      <StyledUserWrapper>
        <StyledLink href={logInUrl} onClick={onLogInClicked}>
          Log In
        </StyledLink>
        <StyledDivider />
        <StyledLink href={signUpUrl} onClick={onSignUpClicked}>
          Sign Up
        </StyledLink>
      </StyledUserWrapper>
    );
  else
    return (
      <StyledUserWrapper>
        <StyledLink full href={logInUrl} onClick={onLogInClicked}>
          Log In
        </StyledLink>
      </StyledUserWrapper>
    );
};
